export const handleConvertClasses = () => {
    const allCellsStart = document.querySelector('.ant-picker-cell.ant-picker-cell-disabled.ant-picker-cell-range-start.ant-picker-cell-range-end.ant-picker-cell-in-view');
    const allCellsEnd = document.querySelector('.ant-picker-cell.ant-picker-cell-disabled.ant-picker-cell-range-start.ant-picker-cell-in-view');
    if (allCellsStart || allCellsEnd) {
        const allCells = allCellsStart || allCellsEnd;
        allCells.style.color = 'white';
    }
};
//# sourceMappingURL=convertClasses.js.map